import { render, staticRenderFns } from "./ReleaseSuccess.vue?vue&type=template&id=23395416&scoped=true&"
import script from "./ReleaseSuccess.vue?vue&type=script&lang=js&"
export * from "./ReleaseSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseSuccess.vue?vue&type=style&index=0&id=23395416&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23395416",
  null
  
)

export default component.exports